/**
 * 发卡活动时间工具
 *
 * 后端 @JsonFormat(timezone = "GMT+8") 返回的是 GMT+8 的墙上时间，
 * 直接 new Date('yyyy-MM-dd HH:mm:ss') 会按浏览器本地时区解释，
 * 非 GMT+8 环境会整体偏移。这里统一按 GMT+8 解析成时间戳。
 */

const BACKEND_TIME_PATTERN = /^(\d{4})-(\d{2})-(\d{2})[ T](\d{2}):(\d{2}):(\d{2})(?:\.\d+)?$/

export function parseCardGrantTime(time) {
  if (time === null || time === undefined || time === '') return NaN
  if (time instanceof Date) return time.getTime()

  const text = String(time).trim()
  const matched = BACKEND_TIME_PATTERN.exec(text)
  if (matched) {
    return Date.UTC(
      Number(matched[1]),
      Number(matched[2]) - 1,
      Number(matched[3]),
      Number(matched[4]) - 8,
      Number(matched[5]),
      Number(matched[6])
    )
  }

  return new Date(text).getTime()
}

export function getCardGrantPeriodState(startTime, endTime, now) {
  const start = parseCardGrantTime(startTime)
  const end = parseCardGrantTime(endTime)
  if (!Number.isFinite(start) || !Number.isFinite(end)) return ''

  const current = Number.isFinite(now) ? now : Date.now()
  if (current < start) return 'notStart'
  if (current > end) return 'ended'
  return 'running'
}
